import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {Router} from '@angular/router';
import {ViewPartnersService} from '../view-partners.service';

@Component({
  selector: 'app-view-partners',
  templateUrl: './view-partners.component.html',
  styleUrls: ['./view-partners.component.css'],
  providers: [ViewPartnersService]
})
export class ViewPartnersComponent implements OnInit {

  private gridData: any;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ViewPartnersService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.call(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.componentService.getData().then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.gridData = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  editHandler(event) {
    this.router.navigate(['/manage/partner'], { queryParams: { id: event.dataItem.id } });
  }

}



// WEBPACK FOOTER //
// ./src/app/view-partners/view-partners.component.ts